import { render, staticRenderFns } from "./ExpenseClaimForm.vue?vue&type=template&id=6b00c938"
import script from "./ExpenseClaimForm.vue?vue&type=script&lang=js"
export * from "./ExpenseClaimForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports